const regexMetaDesc = /.*?(\.)(?=\s[A-Z])/;

export const GetFirstSentenceFromRichText = (str) => {
  if (str !== undefined) {
    const cleanStr = str.replace(/<\/?[^>]+(>|$)/g, "");
    let results;
    if ((results = regexMetaDesc.exec(cleanStr)) !== null) {
      return results[0]
    } else {
      return cleanStr
    }
  }
  return ''
}